// extracted by mini-css-extract-plugin
export default {"container":"navigation_container__vWiP-"};